import { locales, options } from '../../../../shared/date-formatter';
import {
  dmyLeadZerosWSlash,
  mdyLeadZerosWSlash,
  ymdLeadZerosWSlash,
} from '@/constants/dateTime';

export function getMomentDateFormat(datetimeFormat: string): string {
  if (!datetimeFormat || typeof datetimeFormat !== 'string') {
    return mdyLeadZerosWSlash;
  }

  const knownFormats: { [key: string]: string } = {
    'MM/DD/YYYY HH:MM': mdyLeadZerosWSlash,
    'MM/DD/YYYY HH:MM:SS': mdyLeadZerosWSlash,
    'DD/MM/YYYY HH:MM': dmyLeadZerosWSlash,
    'DD/MM/YYYY HH:MM:SS': dmyLeadZerosWSlash,
    'YYYY/MM/DD HH:MM': ymdLeadZerosWSlash,
    'YYYY/MM/DD HH:MM:SS': ymdLeadZerosWSlash,
  };

  if (knownFormats[datetimeFormat]) {
    return knownFormats[datetimeFormat];
  }

  if (datetimeFormat === 'User Browser Setting') {
    const locale = locales[datetimeFormat] || navigator.language || 'en-US';

    try {
      const parts = new Intl.DateTimeFormat(
        locale,
        options.date,
      ).formatToParts();

      const partOrder: string[] = [];
      let separator = '/';

      for (const part of parts) {
        if (
          part.type === 'year' ||
          part.type === 'month' ||
          part.type === 'day'
        ) {
          partOrder.push(part.type);
        } else if (part.type === 'literal' && part.value && separator === '/') {
          separator = ['/', '.', '-'].includes(part.value) ? part.value : '/';
        }
      }

      const momentFormatParts: string[] = [];
      for (const partType of partOrder) {
        switch (partType) {
          case 'year':
            momentFormatParts.push('YYYY');
            break;
          case 'month':
            momentFormatParts.push('MM');
            break;
          case 'day':
            momentFormatParts.push('DD');
            break;
        }
      }

      if (momentFormatParts.length === 3) {
        const momentFormat = momentFormatParts.join(separator);

        if (momentFormat === mdyLeadZerosWSlash) {
          return mdyLeadZerosWSlash;
        } else if (momentFormat === dmyLeadZerosWSlash) {
          return dmyLeadZerosWSlash;
        } else if (momentFormat === ymdLeadZerosWSlash) {
          return ymdLeadZerosWSlash;
        } else {
          const normalizedFormat = momentFormatParts.join('/');
          if (normalizedFormat === mdyLeadZerosWSlash) {
            return mdyLeadZerosWSlash;
          } else if (normalizedFormat === dmyLeadZerosWSlash) {
            return dmyLeadZerosWSlash;
          } else if (normalizedFormat === ymdLeadZerosWSlash) {
            return ymdLeadZerosWSlash;
          }
        }
      }
    } catch (error) {
      console.warn(
        'Failed to detect browser date format, falling back to MM/DD/YYYY',
        { locale, error },
      );
    }

    return mdyLeadZerosWSlash;
  }

  const datePart = datetimeFormat.split(' ')[0];

  if (datePart.includes('/')) {
    const parts = datePart.split('/');
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        return ymdLeadZerosWSlash;
      } else if (parts[0].length === 2 && parts[2].length === 4) {
        return mdyLeadZerosWSlash;
      }
    }
  }

  return mdyLeadZerosWSlash;
}
